import { Disclosure, Menu } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { FaInstagram, FaGithub, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { motion } from "framer-motion";
import sg from "../../assets/SkillsImage/sg.png";

const navigation = [
  { name: "Home", href: "/", current: false },
  { name: "About", href: "/about", current: false },
  { name: "Projects", href: "/projects", current: false },
  { name: "Contact", href: "/contact", current: false },
  { name: "Skills", href: "/skills", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar({ transparent, opacity }) {
  return (
    <Disclosure
      as="nav"
      className={`fixed w-full z-50 ${
        transparent ? "bg-transparent" : "bg-stone-950"
      }`}
      style={{ backgroundColor: `rgba(20, 83, 45, ${opacity})` }}
    >
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-center">
                <a
                  href="/"
                  className="absolute inset-y-0 left-0 flex items-center"
                >
                  <img
                    className="block h-12 w-12 lg:hidden hover:bg-green-800 animate-spin"
                    src={sg}
                    alt="Your Company"
                  />
                  <img
                    className="hidden h-34 w-12 lg:block hover:bg-green-800 hover:animate-spin hover:rounded-full"
                    src={sg}
                    alt="Your Company"
                  />
                </a>
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4 justify-center">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-900 text-white "
                            : "text-gray-300 hover:bg-green-800 hover:text-slate-50",
                          "rounded-md px-3 py-2 text-sm font-medium "
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div className="flex flex-row">
                    <motion.a
                      href="https://github.com/sertacgltkn"
                      whileHover={{ scale: 1.1 }}
                      className="text-gray-300 hover:bg-slate-900 hover:rounded-lg"
                      target="_blank"
                      rel="noopener noreferrer"
                      animate={{
                        opacity: 1,
                        boxShadow: "0px 2px 0px 0px rgba(0, 255, 0, 0.3)",
                      }}
                    >
                      <FaGithub className="w-6 h-6" />
                    </motion.a>
                    <motion.a
                      href="https://www.instagram.com/sertacgultekinn/?hl=tr"
                      whileHover={{ scale: 1.1 }}
                      className="text-gray-300 hover:bg-slate-900 hover:rounded-lg ml-3"
                      target="_blank"
                      rel="noopener noreferrer"
                      animate={{
                        opacity: 1,
                        boxShadow: "0px 2px 0px 0px rgba(0, 255, 0, 0.3)",
                      }}
                    >
                      <FaInstagram className="w-6 h-6" />
                    </motion.a>
                    <motion.a
                      href="https://www.linkedin.com/in/sertacgultekin/"
                      whileHover={{ scale: 1.1 }}
                      className="text-gray-300 hover:bg-slate-900 hover:rounded-full ml-3"
                      target="_blank"
                      rel="noopener noreferrer"
                      animate={{
                        opacity: 1,
                        boxShadow: "0px 2px 0px 0px rgba(0, 255, 0, 0.3)",
                      }}
                    >
                      <FaLinkedinIn className="w-6 h-6" />
                    </motion.a>
                    <motion.a
                      href="https://twitter.com/sertacgltkn"
                      whileHover={{ scale: 1.1 }}
                      className="text-gray-300 hover:bg-slate-900 hover:rounded-full ml-3"
                      target="_blank"
                      rel="noopener noreferrer"
                      animate={{
                        opacity: 1,
                        boxShadow: "0px 2px 0px 0px rgba(0, 255, 0, 0.3)",
                      }}
                    >
                      <FaTwitter className="w-6 h-6" />
                    </motion.a>
                  </div>
                </Menu>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block rounded-md px-3 py-2 text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
